// extracted by mini-css-extract-plugin
export var select = "_oi-0";